<template>
  <div>
    <v-alert
      v-if="alertaid != 'proveedor'"
      v-model="alert"
      dismissible
      type="warning"
    >
      No existen datos para mostrar en el contrato seleccionado!
    </v-alert>
    <v-alert v-else v-model="alert" dismissible type="warning">
      No tiene ningún contrato asociado!
    </v-alert>
  </div>
</template>
<script>
export default {
  props: {
    alertaid: String,
  },
  data() {
    return {
      alert: true,
    };
  },
};
</script>
